<template>
  <div class="UpdatePopover">
    <van-popup v-model="showPopup" position="bottom" @close="onClose" :style="{ height: '60%' }" :closeable="true">
      <div class="popoverContent">
        <div class="popoverContentTop">
          <div class="title">名称变更</div>
        </div>

        <div class="popoverContentMid">
          <div class="item temr" >
            <div class="label">原企业名称</div>
            <div class="value">{{corpName}}</div>
          </div>
          <div class="item temr">
            <div class="label">变更后企业名称</div>
            <div class="inputItem">
              <input class="inputContainer" placeholder="请输入企业名称" :maxLength="50" v-model="newCorpName" type="text" />
              <van-icon v-if="newCorpName" @click="allowClear" class="cross" name="cross" />
            </div>
          </div>
        </div>
        <div class="buttonGroup">
          <div class="cancel" @click="onCancel">取消</div>
          <div class="submit" @click="onDetermine">确认</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';
function debounce(func, wait) {
  let timeout;
  return function (...argument) {
    const context = this;
    const args = argument;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}
export default {
  name: 'InvoiceDetails',
  props: {
    value: {
      type: Boolean,
    },
    corpName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showPopup: false,
      newCorpName: ''
    };
  },
  mounted() { },
  watch: {
    value: {
      handler(newValue) {
        this.showPopup = newValue;
        this.newCorpName = ''
      },
      immediate: true,
    },
  },
  methods: {
    allowClear() {
      this.newCorpName = ''
    },
    onClose() {
      this.$emit('input', false);
    },
    onDetermine: debounce(function () {
      if(!this.newCorpName) return Toast('请输入变更后企业名称');
      this.$emit('onSubmit', this.newCorpName);
    }, 500),
    onCancel() {
      this.$emit('input', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.buttonGroup {
  display: flex;
  height: 68px;
  background: #fff;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border-top: 0.5px solid #cccccc;
  box-sizing: border-box;
  .cancel {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #2f3133;
    text-align: center;
    font-weight: 400;
    text-align: center;
    line-height: 44px;
    height: 44px;
    background: #ffffff;
    border: 1px solid #bcc2cc;
    border-radius: 4px;
    flex: 1;
    margin-right: 15px;
  }
  .submit {
    background: #ff6538;
    border-radius: 4px;
    flex: 1;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    font-weight: 600;
    height: 44px;
    line-height: 44px;
    height: 44px;
  }
}
.UpdatePopover {
  width: auto;
  height: auto;
}
.InvoiceDetails {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  font-family: "Microsoft YaHei";
  padding: 0 16px;
}
.popoverContent {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.popoverContentMid {
  text-align: left;
  flex: 1;
  overflow: hidden;
  .item {
    padding: 16px 16px;
    position: relative;
    .inputItem {
      display: flex;
      align-items: center;
      .inputContainer {
        display: inline-block;
        border: none;
        font-size: 14px;
        padding: 0;
        flex: 1;
      }
      .cross {
        margin: 0 8px;
        color: #9e9fa0;
      }
    }

    .label {
      font-size: 14px;
      color: #1c2438;
      display: flex;
      align-items: center;
      margin-bottom: 16px;
    }
    .value {
      font-size: 14px;
    }
  }
}
.title {
  text-align: left;
  font-size: 14px;
  color: #2f3133;
  font-weight: 600;
  margin: 16px 0 16px 16px;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
</style>
